import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const PsychotherapyTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter members who are in Psychotherapy Task Group
  const getTaskGroupMembers = () => {
    if (!teamData.boardMembers || !teamData.honoraryMembers) return [];

    const allMembers = [
      ...teamData.boardMembers,
      ...teamData.honoraryMembers
    ].filter(member =>
      member.taskGroups && member.taskGroups.includes('Psychotherapy Task Group')
    );

    // Define the desired order
    const memberOrder = [
      'Jacek Lelonkiewicz',
      'Manfred Vogt',
      'Ritta Malkamäki',
      'Marie-Christine Cabié',
      'Rytis Pakrosnis',
      'Ursula Buehlmann',
      'Mark Beyebach'
    ];

    // Sort members according to the defined order
    return allMembers.sort((a, b) => {
      const indexA = memberOrder.indexOf(a.name);
      const indexB = memberOrder.indexOf(b.name);

      // If both are in the order list, use that order
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }

      // If only a is in the order list, it comes first
      if (indexA !== -1) return -1;

      // If only b is in the order list, it comes first
      if (indexB !== -1) return 1;

      // If neither are in the list, keep original order
      return 0;
    });
  };

  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const activityCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginBottom: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link 
          to="/task-groups" 
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          🏥 Psychotherapy Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Working towards European recognition of the Solution Focused approach in psychotherapy
        </p>
      </div>

      {/* Mission */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎯</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Mission</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          The Psychotherapy Task Group is aiming at getting European recognition of the Solution Focused approach. 
          This would be a recognition by the European Association for Psychotherapy.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          This approval procedure implies a thorough and detailed description of the SF approach and how it 
          differentiates itself from other approaches.
        </p>
      </div>

      {/* Activities */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>⚡</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Current Activities</h2>
        </div>
        
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem'}}>
          
          {/* Documentation Work */}
          <div style={{...activityCardStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#2563eb'}}>📝</div>
              <h4 style={{color: '#1e40af', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Documentation Work</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Developing comprehensive documentation of Solution Focused theory, methodology, and practice 
              standards required for European recognition.
            </p>
          </div>

          {/* Research Collaboration */}
          <div style={{...activityCardStyle, backgroundColor: '#fef3c7', border: '1px solid #fde047'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#d97706'}}>🔬</div>
              <h4 style={{color: '#a16207', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Research Collaboration</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Working closely with the Research Task Group to compile evidence-based support for 
              the effectiveness and distinctiveness of Solution Focused approaches.
            </p>
          </div>

        </div>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Task Group Members</h2>
        </div>
        
        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getTaskGroupMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '0.5rem'}}>
                  {member.name}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Contact & Support */}
      <div style={{...sectionStyle, backgroundColor: '#f1f5f9', textAlign: 'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>📧</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Get Involved</h2>
        </div>
        <p style={{fontSize: '1.1rem', color: '#64748b', marginBottom: '1.5rem', maxWidth: '600px', margin: '0 auto 1.5rem'}}>
          Interested in supporting European recognition of Solution Focused psychotherapy?
        </p>
        <p style={{fontSize: '1rem', color: '#64748b', marginBottom: '2rem'}}>
          Contact our Psychotherapy Task Group to learn about recognition efforts and how you can contribute.
        </p>
        <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center'}}>
          <Link 
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#2563eb',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1d4ed8';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2563eb';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>📧</span>
            Contact Us
          </Link>
          <Link 
            to="/research"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#059669',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '10px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '1rem',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#047857';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#059669';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <span style={{marginRight: '0.5rem'}}>🔬</span>
            View Research
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PsychotherapyTaskGroup;
